import { createFileRoute } from '@tanstack/react-router'
import { PERMISSION_ROLES } from '../../src/constants/premissions'
import { businessDashboardSearchSchema, healthQueryOptions } from '../../src/schemas/routeSchemas'
import { requirePermission } from '../../src/utils/routePermissions'

export const Route = createFileRoute('/business-dashboard')({
  validateSearch: (search) => businessDashboardSearchSchema.parse(search),
  loaderDeps: () => ({}),
  beforeLoad: ({ context }) => {
    requirePermission(context, Route.options.staticData?.permissionRequired)
  },
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(healthQueryOptions)
  },
  staticData: {
    permissionRequired: PERMISSION_ROLES.BUSINESS_DASHBOARD,
    layout: 'menu',
  },
})
